import type { StateTree } from '@makemydeal/dr-dash-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

export const getDealValidationState = (state: StateTree) => {
    return state.dealValidation;
};

export const getInCompleteDealCoOrgId = (state: StateTree) => {
    return state.dealValidation?.commonOrgId || '';
};

export const isDealValid = (state: StateTree): boolean => {
    if (!featureToggleSelectors.areFeatureTogglesAvailable(state)) {
        return false;
    }

    const { mvDealValidation } = featureToggleSelectors.getFeatureToggles(state);

    if (!mvDealValidation) {
        return true;
    }

    return !!state.dealValidation?.valid;
};

export const getIsEmployee = (state: StateTree): boolean => {
    return !!state.dealValidation?.isEmployee;
};

export const getShowDealershipSelectionModal = (state: StateTree): boolean => {
    if (!featureToggleSelectors.areFeatureTogglesAvailable(state)) {
        return false;
    }
    if (!featureToggleSelectors.isManagerViewQuoteModeEnabled(state)) {
        return false;
    }
    return !isDealValid(state) && !!getDealValidationState(state)?.missingDealership;
};
